import { ApiGetFontDownload } from "admin/api/fonts";

// Window型にカスタムプロパティを追加
declare global {
  interface Window {
    __CUSTOM_FONT_FAMILIES__?: string[];
  }
}

export async function loadCustomFonts() {
  // フォント事前読み込みとfont-familyの動的適用
  // パスから自治体コードを取得（例: /nara-city/）
  const pathMatch = window.location.pathname.match(/^\/?([\w-]+)\//);
  const governmentCode =
    pathMatch &&
    pathMatch[1] &&
    pathMatch[1] !== "admin" &&
    pathMatch[1] !== "server-error"
      ? pathMatch[1]
      : window.location.hostname.split(".")[0] !== "localhost" &&
        window.location.hostname.split(".")[0] !== "admin"
      ? window.location.hostname.split(".")[0]
      : "";
  ApiGetFontDownload(governmentCode)
    .then((res: any) => {
      // レスポンスが配列でなければ空配列に
      const fonts = res.result || [];
      const fontNames: string[] = [];

      // 各フォントデータを処理
      fonts.forEach(
        (font: { fileName?: string; url?: string }, idx: number) => {
          // フォント名を決定（fileNameがなければCustomFont+連番）
          const fontName = font.fileName || `CustomFont${idx + 1}`;
          fontNames.push(fontName);

          // フォントファイルの拡張子からformatを自動判定
          let format = "woff2";
          if (font.url) {
            // クエリパラメータを除外して拡張子のみ取得
            const ext = font.url.split("?")[0].split(".").pop()?.toLowerCase();
            if (ext === "ttf") format = "truetype";
            else if (ext === "otf") format = "opentype";
            else if (ext === "woff") format = "woff";
            else if (ext === "woff2") format = "woff2";
          }

          // @font-faceルールをstyle要素で動的に追加
          const style = document.createElement("style");
          style.innerText = `@font-face { font-family: '${fontName}'; src: url('${font.url}') format('${format}'); font-display: swap; }`;
          // headタグ内に追加することで、グローバルにフォントが利用可能になります
          document.head.appendChild(style);
        }
      );

      // フォント名リストをwindowに保存（他コンポーネントで利用可能に）
      window.__CUSTOM_FONT_FAMILIES__ = fontNames;

      // カスタムプロパティでfont-familyを動的に設定（index.cssで利用）
      if (fontNames.length > 0) {
        const customFontFamily = fontNames.map((n) => `"${n}"`).join(", ");
        document.documentElement.style.setProperty(
          "--custom-font-family",
          customFontFamily
        );
      } else {
        document.documentElement.style.removeProperty("--custom-font-family");
      }
    })
    .catch((error) => {
      console.error("フォントの事前読み込みに失敗しました", error);
    });
}
